import {
  deleteRequest,
  putRequest,
  getRequest,
  postRequest,
} from "../../utils/api";

// 查询AEP设备上报信息列表
export function listAeprepoprt(query) {
  return getRequest('/api/aep/list',query)
}

export function listAepDeviceInfo() {
  return getRequest('/api/aep/info/dictionary',query)
}
